module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.categoriasLeilao !== null) ? _c('u-button-group', {
    attrs: {
      "options": _vm.categoriasLeilao
    },
    model: {
      value: (_vm.model),
      callback: function($$v) {
        _vm.model = $$v
      },
      expression: "model"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.categoriasLeilao === null && !_vm.loadError) ? _c('u-fake-loader', {
    staticClass: "m-t",
    attrs: {
      "width": "320px"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.loadError) ? _c('u-button', {
    staticClass: "btn btn-xs m-t-xs",
    on: {
      "click": function($event) {
        return _vm.load()
      }
    }
  }, [_c('i', {
    staticClass: "icon icon-reload"
  }), _vm._v(" Erro ao carregar as categorias, tente novamente")]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2c96c8d0","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/website/leiloes/components/SelectCategoria.vue
// module id = 1572
// module chunks = 17